import {Image} from '../../../../components/image/image';
import {TimeBlock} from '../time-block/time-block';
import React from 'react';
import ArtistLineup from '../artist-lineup/artist-lineup';
import {CtaButton} from '../cta-button/cta-button';
import LinearText from '../linear-text/linear-text';
import ShowcaseCard from '../showcase-card/showcase-card';

const featureCardsData = [
    {
        title: 'ĐẠI TIỆC ÂM NHẠC \nCẢM XÚC',
        description: 'Dành cho khách hàng',
    },
    {
        title: 'SỰ KIỆN ÂM NHẠC \nTRI ÂN',
        description: 'Món quà ý nghĩa KidsPlaza trao tặng khách hàng',
    },
    {
        title: 'SÂN KHẤU \nVƯƠN MÌNH TƯƠNG LAI',
        description: 'Nơi kết hợp nghệ thuật, cảm xúc và khát vọng vươn xa',
    },
];
const HeroBanner = () => {
    const scrollToRegisterSection = () => {
        const registerSection = document.getElementById('register-section');
        if (registerSection) {
            registerSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });

            // Fallback for browsers that don't support smooth scrolling well
            // hoặc custom scroll animation for more control
            if (CSS.supports('scroll-behavior', 'smooth')) {
                // Browser supports smooth scroll natively
                return;
            } else {
                // Custom smooth scroll for better control
                const targetPosition = registerSection.offsetTop;
                const startPosition = window.pageYOffset;
                const distance = targetPosition - startPosition;
                const duration = 1200; // 1.2 seconds for smoother animation
                let start: number | null = null;

                const smoothScrollStep = (timestamp: number) => {
                    if (!start) start = timestamp;
                    const progress = timestamp - start;
                    const percentage = Math.min(progress / duration, 1);

                    // Easing function for smoother animation
                    const ease = 0.5 * (1 - Math.cos(percentage * Math.PI));

                    window.scrollTo(0, startPosition + distance * ease);

                    if (progress < duration) {
                        window.requestAnimationFrame(smoothScrollStep);
                    }
                };

                window.requestAnimationFrame(smoothScrollStep);
            }
        }
    };

    return (
        <div
            className="relative w-full max-h-[1862px] xl:max-h-[1862px]
		aspect-[1/3.7]
    xs:aspect-[1/3]
		sm:aspect-[1/2.5]
    md:aspect-[1/2.15]
    lg:aspect-[1/2]
		xl:aspect-[1/1.5]
		bg-[#0b0033] overflow-hidden font-sans text-center text-white"
            style={{position: 'relative'}}>
            {/* z-0: Background */}
            <Image
                src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/hero-bg.png"
                alt="Background"
                layout="fill"
                objectFit="cover"
                className="z-0 -py-1"
                priority
            />

            {/* z-20: Stage Lights */}
            <div className="absolute top-[1%] w-full h-1/3 ">
                <Image
                    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/hero-stage-lights.png"
                    alt="Stage Lights"
                    layout="fill"
                    objectFit="contain"
                    objectPosition="top"
                    className="mix-blend-lighten"
                />
            </div>

            {/* z-30: City Effect (ĐÃ TĂNG KÍCH THƯỚC VÀ ĐIỀU CHỈNH) */}
            <div
                className="absolute
			top-[5%]
			xxs:top-[7%]
			xs:top-[6%]
			sm:top-[12%]
			md:top-[15%]
      lg:top-[17%]
			xl:top-[20%]
			3xl:top-[20%]
			 w-full h-1/3">
                <Image
                    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/hero-city-effect-01.png"
                    alt="City Effect"
                    layout="fill"
                    objectFit="contain"
                    objectPosition="top"
                    className="mix-blend-lighten"
                />
            </div>

            <div
                className="absolute
  top-[0%]
  xxs:top-[0%]
  xs:top-[0%]
  sm:top-[0%]
  md:top-[0%]
  lg:top-[10%]
  xl:top-[10%]
			 w-full h-1/3">
                <Image
                    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/phuong-hoang.png"
                    alt="Phượng Hoàng"
                    fill
                    layout="fill"
                    objectFit="contain"
                    objectPosition="top"
                    className="mix-blend-lighten"
                />
            </div>

            {/* Bottom Flare Image */}
            <div
                className="absolute
      top-[15%]
      xxs:top-[18%]
      xs:top-[20%]
      sm:top-[28%]
      md:top-[34%]
      lg:top-[39%]
      xl:top-[45%]
       w-full h-2/3">
                <Image
                    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/hero-bottom-flare.png"
                    alt="Bottom Flare"
                    layout="fill"
                    objectFit="contain"
                    objectPosition="top"
                    className="mix-blend-lighten"
                />
            </div>

            {/* z-40: Artists with Fading Mask (ĐÃ THU HẸP VÀ CĂN GIỮA) */}
            <div
                className="absolute
			top-[1%]
			xxs:top-[2%]
			sm:top-[12%]
			 md:top-[18%]
       lg:top-[25%]
       xl:top-[30%]
       w-[70%] left-0 right-0 mx-auto ">
                <div className={'flex items-center justify-center'}>
                    <ArtistLineup />
                </div>
            </div>

            {/* z-50: Logo */}
            <div
                className="absolute
			top-[3%]
			w-[35%]
			sm:w-[50%] md:w-[45%] lg:w-[30%] xl:w-[50%]  mx-auto left-0 right-0">
                <Image
                    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/hero-logo.webp"
                    alt="Vươn Concert Logo"
                    objectFit="contain"
                    width={480}
                    height={341}
                    className={'mx-auto'}
                />
            </div>

            {/* z-60: Bottom Flare, Text & CTA */}
            <div
                className="absolute w-full h-full flex flex-col items-center md:pb-5
                top-[22%]
                xs:top-[25%]
                sm:top-[35%]
                md:top-[40%]
                lg:top-[48%]
                xl:top-[55%]
                "
                style={{position: 'absolute', zIndex: 100}}>
                {/* Text Info */}
                <div className="relative text-white text-center ">
                    <TimeBlock location="SÂN VẬN ĐỘNG QUẦN NGỰA" time="20:00" day="CHỦ NHẬT" date="05.10.2025" />
                </div>

                <div className={'px-1 w-full mx-auto'}>
                    <CtaButton
                        text={
                            <>
                                <p className={'uppercase text-[16px] lg:text-[36px]'}>{'ĐĂNG KÝ NHẬN VÉ'}</p>
                                <p className="text-[16px]">(Miễn phí)</p>
                            </>
                        }
                        className={'mx-auto w-[20%] min-w-[291px] max-w-[665px]'}
                        contentClassName="font-next_roboto font-bold text-[16px] lg:text-[36px]"
                        onClick={scrollToRegisterSection}
                    />
                </div>

                <section className="mt-11 relative px-2">
                    <LinearText className="mt-2 text-[36px] lg:text-[56px] font-kpz_font font-extrabold bg-[linear-gradient(to_right,_#6CF5FF_0%,_#92C3F3_41%,_#FF77E1_76%,_#FF398C_100%)] bg-clip-text text-transparent drop-shadow-lg">
                        VƯƠN CONCERT
                    </LinearText>
                    <p className="font-montserrat mx-auto mt-5 max-w-3xl text-sm md:text-lg font-bold leading-relaxed">
                        Âm nhạc chưa bao giờ chỉ là giai điệu. Đó là tiếng thì thầm ru con ngủ trong vòng tay mẹ, là
                        khúc ca hồn nhiên cha hát cho con vào những ngày đầu đời, là nhịp điệu trẻ trung đồng hành cùng
                        cha mẹ Gen Z trong guồng sống hiện đại. Mỗi thanh âm đều mang sức mạnh đặc biệt: kết nối cảm
                        xúc, lưu giữ kỷ niệm và tiếp thêm năng lượng tích cực cho cả gia đình trên hành trình nuôi dạy
                        con.
                    </p>
                </section>

                <section className="mt-9 w-full max-w-[1200px] relative px-4 md:!px-0">
                    <div className="gap-6 flex flex-wrap justify-center items-center">
                        {featureCardsData.map(card => (
                            <ShowcaseCard key={card?.title} headline={card.title} description={card.description} />
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default HeroBanner;
